import Request from './Request'
import { spreedParams } from './utils'
const md5 = require('md5');

class Http extends Request {
    constructor(options = {}) {
      super(options)
      this.cacheStore = {
        cache_key: {
          handler: Promise.resolve('result'),
          expired_at: 0 // or Date().getTime()
        }
      }
    }
    get(url, preload) {
      const { params, call } = spreedParams(preload)
      return this.axiosRequest('get', url, params, call)
    }
    // expired: Number(seconds), 0 页面关闭时过期
    async cacheGet(url, preload = {}, options = {expired: 0}) {
      const cache_key = `${url}-${md5(JSON.stringify(preload))}`;
      const cache = this.cacheStore[cache_key];
      const now = new Date().getTime();
      if (cache) {
        const expired = cache.expired_at > 0 && now > cache.expired_at;
        if (expired) {
          this.cacheStore[cache_key] = null;
        } else {
          return Promise.resolve(await cache.handler);
        }
      }
      const result_func = () => {
        return this.get(url, preload);
      };
      const result = result_func();
      this.cacheStore[cache_key] = {handler: result};
      this.cacheStore[cache_key]['expired_at'] = options.expired ? (now + options.expired * 1000) : 0;
      return await result;
    }
    post(url, preload) {
      const { params, call } = spreedParams(preload)
      return this.axiosRequest('post', url, params, call);
    }
    del(url, preload) {
      const { params, call } = spreedParams(preload)
      return this.axiosRequest('delete', url, params, call);
    }
    put(url, preload) {
      const { params, call } = spreedParams(preload)
      return this.axiosRequest('put', url, params, call);
    }
    patch(url, preload) {
      const { params, call } = spreedParams(preload)
      return this.axiosRequest('patch', url, params, call);
    }
    head(url, preload) {
      const { params, call } = spreedParams(preload)
      return this.axiosRequest('head', url, params, call);
    }
    post_upload(url, preload) {
      let params_clone = null
      let call_clone = null
      if (Object.prototype.toString.apply(preload) === "[object FormData]") {
        params_clone = preload
        call_clone = {}
      } else {
        const { params, call } = spreedParams(preload)
        call_clone = call
        Object.keys(params).forEach(key => {
          params_clone = params[key]
        })
      }
      return this.axiosRequest('post_upload', url, params_clone, call_clone);
    }
    post_download(url, preload) {
      const { params, call } = spreedParams(preload)
      return this.axiosRequest('post_download', url, params, call);
    }
}

export default Http
